// quick-add.js (reemplaza contenido)
document.addEventListener('DOMContentLoaded', () => {
  const quickAddButtons = document.querySelectorAll('.js-quick-add-btn');

  function showToast(product) {
    const toast = document.getElementById('mini-cart-toast');
    if (!toast) return;
    const nameEl = document.getElementById('mini-cart-toast-name');
    const imgEl = document.getElementById('mini-cart-toast-img');

    if (nameEl) nameEl.textContent = product.title || '';
    if (imgEl) imgEl.src = product.image || '';

    toast.style.display = "flex";
    requestAnimationFrame(() => toast.classList.add('show'));

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.style.display = "none", 300);
    }, 3500);
  }

  async function updateCartCountAndNotify() {
    try {
      const resp = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!resp.ok) return;
      const cartJson = await resp.json();

      // Actualiza burbujas / numeritos
      document.querySelectorAll('.cart-link__bubble, .cart-link__bubble-num').forEach(el => {
        // Si hay un elemento num
        if (el.classList.contains('cart-link__bubble-num')) {
          el.textContent = cartJson.item_count;
        } else {
          el.textContent = cartJson.item_count;
          if (cartJson.item_count > 0) el.classList.add('cart-link__bubble--visible');
          else el.classList.remove('cart-link__bubble--visible');
        }
      });

      // Notifica al theme (listeners que esperen cart:updated)
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartJson } }));

      return cartJson;
    } catch (e) {
      console.warn('updateCartCountAndNotify error', e);
    }
  }

  quickAddButtons.forEach(button => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      if (button.disabled) return;

      const variantId = button.dataset.defaultAvailable === "true"
        ? button.dataset.defaultVariantId
        : button.dataset.firstAvailableVariantId;

      if (!variantId) {
        button.disabled = true;
        button.setAttribute('title', 'Agotado');
        return;
      }

      // Previene double click
      button.disabled = true;

      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        // Si error de validación, mostrarlo
        if (!resp.ok) {
          const errJson = await resp.json().catch(() => ({}));
          console.warn('Add to cart failed', errJson);
          // opcional: mostrar mensaje al usuario
          return;
        }

        const data = await resp.json();

        // Preparar datos para el toast
        const productTitle = data.product_title || data.title || '';
        let productImage = '';
        if (data.image) {
          if (typeof data.image === 'string') productImage = data.image;
          else if (data.image.src) productImage = data.image.src;
        }
        // fallback: imagen del card
        if (!productImage) {
          const cardImg = button.closest('.product-card')?.querySelector('img');
          if (cardImg) productImage = cardImg.src;
        }

        // Mostrar toast y actualizar contador
        showToast({ title: productTitle, image: productImage });
        await updateCartCountAndNotify();

        // ==> Aquí: pedimos que el theme reconstruya el drawer en background (sin abrirlo)
        // CartForm escucha 'cart:build' y ejecuta theme.cart.getCartProductMarkup() -> cartMarkup()
        document.dispatchEvent(new CustomEvent('cart:build'));

        // Nota: NO disparamos 'ajaxProduct:added' porque el listener del drawer abre el drawer.
        // Si en algún caso quieres que además se abra: document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: data }));

      } catch (err) {
        console.error('Error en quick-add:', err);
      } finally {
        // re-enable tras pequeña demora
        setTimeout(() => { button.disabled = false; }, 600);
      }
    });
  });
});
